
<template>
  <div>
    <h1>{{asset.name}}</h1>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <div class="card m-3 bg-light">
            <div class="card-body" style="height:100%">
              <network
                class="network visContainer"
                :ref="`${asset.$id}`"
                :nodes="asset.network.nodes"
                :edges="asset.network.edges"
                :options="asset.network.options"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <button @click="duplicate()">duplicate</button>
  </div>
</template>
<script>
import { fetchAsset } from "../firebase/firebase";
import { DataSet } from "vue2vis";
export default {
  name: "asset",
  data() {
    return {
      unsubscribe: null,
      name: "",
      asset: null,
      currentSelectedNode: null
    };
  },
  async created() {
    this.unsubscribe = fetchAsset(this.$route.params.schoolId,this.$route.params.assetId ).onSnapshot(
      querySnapshot => {
       const $data = querySnapshot.data()       
        this.asset =          {
            $id: querySnapshot.id,
            name: $data.name,
            network: {
              nodes: new DataSet($data.nodes),
              edges: new DataSet($data.edges),
              options: {
                groups: {
                  switch: {
                    shape: "box",
                    color: "#24d453" // green
                  }
                }
              }
            }
          }
      }
    );
  },
  destroyed() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }
};
</script>
<style scoped>

.main {
  height: 100%;
  display: flex;
}

.visContainer {
  height: 100%;
  width: 100%;
}

.detailContainer {
  width: 35%;
  height: 100%;
  position: absolute;
  right: 0;
  opacity: 0.85;
  background: #000;
  padding: 10px;
  color: #fff;
}

.detailContents {
  color: #fff;
  margin: 10px;
}

.white {
  display: block; height: 1px;
    border: 0; border-top: 1px solid #ccc;
    margin: 1em 0; padding: 0; 
}

.materials {
  font-size: smaller
}

.rating {

}

</style>